import React from "react";
import i18n from "../../i18n";

const LanguageSelector: React.FC = () => {
    const changeLanguage = (lang: string): void => {
        i18n.changeLanguage(lang);
    };

    return (
        <div className="absolute top-4 right-4 flex gap-4 z-50">
            <img
                src="/flags/spain.svg"
                alt="Español"
                className="w-10 h-6 cursor-pointer hover:scale-110 transition-transform"
                onClick={() => changeLanguage("es")}
            />
            <img
                src="/flags/uk.svg"
                alt="English"
                className="w-10 h-6 cursor-pointer hover:scale-110 transition-transform"
                onClick={() => changeLanguage("en")}
            />
        </div>
    );
};

export default LanguageSelector;
